/* eslint-disable @typescript-eslint/no-explicit-any */
import { HttpClient, HttpRequestConfig } from '../core/HttpClient';
import { HttpClientDecorator } from '../core/HttpClientDecorator';

export class WithAuthorization extends HttpClientDecorator {
  constructor(
    httpClient: HttpClient,
    private readonly token: string,
  ) {
    super(httpClient);
  }

  get<ResponseData = any, ResponseMeta = any>(
    url: string,
    config: HttpRequestConfig = {},
  ): Promise<{ data: ResponseData; meta: ResponseMeta; success: boolean }> {
    return super.get<ResponseData, ResponseMeta>(url, this.addAuthorizationHeaderToConfig(config));
  }

  post<ResponseData = any, ResponseMeta = any>(
    url: string,
    config: HttpRequestConfig = {},
  ): Promise<{ data: ResponseData; meta: ResponseMeta; success: boolean }> {
    return super.post<ResponseData, ResponseMeta>(url, this.addAuthorizationHeaderToConfig(config));
  }

  put<ResponseData = any, ResponseMeta = any>(
    url: string,
    config: HttpRequestConfig = {},
  ): Promise<{ data: ResponseData; meta: ResponseMeta; success: boolean }> {
    return super.put<ResponseData, ResponseMeta>(url, this.addAuthorizationHeaderToConfig(config));
  }

  private addAuthorizationHeaderToConfig(config: HttpRequestConfig = {}): HttpRequestConfig {
    return {
      ...config,
      headers: {
        ...config.headers,
        Authorization: `bearer ${this.token}`,
      },
    };
  }
}
